import { createAsyncThunk } from "@reduxjs/toolkit";
import { endpoints } from "../../../api/endpoints";
import { ICreateReportResponse } from "../../../api/types/reports/ICreateReportResponse";
import { IReportParams } from "../../../api/types/reports/IReportParams";

export const createTicketGridTemplate = createAsyncThunk<
  ICreateReportResponse,
  IReportParams
>("ticketGrids/createTemplate", async (param, thunkAPI) => {
  const result = await endpoints.report.create(param, thunkAPI.signal);
  if (result.reportID) {
    return result;
  }
  throw new Error(result.error ?? `Не удалось создать шаблон "${param.name}"`);
});
